
export const dashboardNav = [
    {url: '/', label: 'Dashboard', key: 'dashboard.index', permissions: []},
]